import { useMutation, useQuery } from '@apollo/client';
import { Empty, message } from 'antd';
import { FC, useState } from 'react';
import {
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Document,
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1FieldsFragment,
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateDocument,
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateMutationVariables,
  IdentityVerificationCaseV1CaseDetailsApplicationReviewInput
} from '../../../../../../generated';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { Checklist } from './checklist';

interface ChecklistContainerProps {
  caseId: string;
}

export const ChecklistContainer: FC<ChecklistContainerProps> = (props) => {
  const [isSuccess, setIsSuccess] = useState(false as boolean);
  const {
    data: caseData,
    loading: caseLoading,
    error: caseError
  } = useQuery(CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Document, {
    variables: {
      id: props.caseId
    }
  });

  const [idVerificationUpdate] = useMutation(CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateDocument);

  const handleComplete = async (values: IdentityVerificationCaseV1CaseDetailsApplicationReviewInput) => {
    try {
      const idVerificationUpdateVariables: CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateMutationVariables = {
        input: {
          id: props.caseId,
          caseDetails: {
            applicationReview: {
              ...values
            }
          }
        }
      };

      const result = await idVerificationUpdate({
        variables: idVerificationUpdateVariables
      });

      if (result.data?.identityVerificationCaseV1Update.status.success) {
        setIsSuccess(result.data?.identityVerificationCaseV1Update?.status?.success as boolean);
        message.success('Affirmations saved successfully');
      } else {
        const { errorMessage = 'Unknown error' } = result.data?.identityVerificationCaseV1Update?.status || {};
        if (errorMessage === 'Unauthorized') {
          message.error("Error: Affirmations can't be saved in this case state");
        } else {
          message.error(`Error saving Affirmations: ${errorMessage}`);
        }
      }
    } catch (error) {
      message.error(`Error saving Affirmations: ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      loading={caseLoading}
      error={caseError}
      hasData={caseData}
      hasDataComponent={
        <Checklist
          data={caseData?.identityVerificationCaseV1 as CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1FieldsFragment}
          onSave={handleComplete}
          isSuccess={isSuccess}
        />
      }
      noDataComponent={<Empty description="No data available" />}
    />
  );
};
